import TodayDiaryCard from './components/TodayDiaryCard';
import LastObservationCard from './components/LastObservationCard';
import AccountCard from './components/AccountCard';

import ChildrenLayout from 'src/app/layouts/ChildrenLayout';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/services/store';
import { ChildrenStoreData } from 'src/shared/types/src';
import { getCurrentChild, getNurserySettings } from 'src/shared/redux-state/src';

const HomeScreen = () => {

    const dispatch = useAppDispatch();
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);


    useEffect(() => {
        refreshNurserySettings(currentChild)
    }, [currentChild.childInstanceKey])

    const refreshNurserySettings = async (currentChild: ChildrenStoreData) => {
        await dispatch(getNurserySettings({ child: currentChild }));
    }

    return (
        <ChildrenLayout fixedFooter={true}>
            <div>
                {
                    (Boolean(currentChild?.systemsEnabled?.eylog) && Boolean(currentChild?.systemAccess?.eylog)) ? 
                        <div className='mg-t-15'><LastObservationCard /></div> 
                    : null
                }
                {
                    (Boolean(currentChild?.systemsEnabled?.eylog) && Boolean(currentChild?.systemAccess?.eylog)) ? 
                        <div className='mg-t-15'><TodayDiaryCard /></div> 
                    : null
                }
                {
                    (Boolean(currentChild?.systemsEnabled?.eymanage) && Boolean(currentChild?.systemAccess?.eymanage)) ? 
                        <div className='mg-t-15'><AccountCard /></div> 
                    : null
                }
            </div>
        </ChildrenLayout>
    )
}

export default HomeScreen